// Copyright (c) 2021 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';

export const getLaborRateRequestStatus = statuses =>
    statuses
        .filter(status => ['01', '02', '03', '04'].includes(status.key))
        .map(status => new KeyValuePair({
            key: status.key,
            value: status.value
        }));



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/services/labor-rate-request-status-helper.js